import type { CursorPage, MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  ApprovalDecisionInput,
  ApprovalDetail,
  ApprovalExecutionInput,
  ApprovalListQuery,
  ApprovalSummary,
} from './types';

export interface ApprovalsRepository {
  list(query: ApprovalListQuery, signal: AbortSignal): Promise<CursorPage<ApprovalSummary>>;
  get(approvalId: string, signal: AbortSignal): Promise<ApprovalDetail>;
  decide(
    approvalId: string,
    input: ApprovalDecisionInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ApprovalDetail>>;
  execute(
    approvalId: string,
    input: ApprovalExecutionInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ApprovalDetail>>;
}

export const approvalsRepositoryToken = createRepositoryToken<ApprovalsRepository>('approvals');

export const defaultApprovalListQuery = Object.freeze<ApprovalListQuery>({
  cursor: '',
  pageSize: 50,
  filters: Object.freeze({
    partnerId: '',
    actionType: '',
    status: '',
    entityType: '',
    entityId: '',
  }),
});
